document.addEventListener('DOMContentLoaded', function () {
  const legendItems = document.querySelectorAll('.legend-item');
  const backButton = document.querySelector('.back-button');
if (backButton) {
  backButton.addEventListener('click', function(e) {
    e.preventDefault();
    const allProducts = document.querySelectorAll('[data-product-id]');
    allProducts.forEach(product => product.style.display = 'block');
  });
}
  const products = document.querySelectorAll('.product-block');

  legendItems.forEach(item => {
    item.addEventListener('click', function (e) {
      e.preventDefault();
      const filterTag = this.getAttribute('data-filter');

      products.forEach(product => {
        const productTags = product.getAttribute('data-tags') || '';
        if (productTags.toLowerCase().includes(filterTag.toLowerCase())) {
          product.style.display = '';
        } else {
          product.style.display = 'none';
        }
      });
    });
  });
});